module.exports = __webpack_public_path__ + "static/img/zhongkong-gongdian.e378f915.png";